//正式环境
//新数据库

// api_base_url: "https://www.ystykj.com:8080/yszbsc/",
//   // api_base_url: "http://iqy75x.natappfree.cc/yszbsc/",
//
//   api_base_url2: "https://www.ystykj.com:9569/",
//   live_message_url: "wss://www.ystykj.com:8080/yszbsc/websocket",
//   live_img_url: "https://www.ystykj.com:9569/",
//   //赛事直播间地
//   live_url: "rtmp://www.ystykj.com:1935/live/",
//   //个人直播间地址
//   personlive_url: 'rtmp://www.ystykj.com:1935/personlive/',


/*测试开发环境Url*/
//接口访问URL
// export const baseUrl='/api';//本地


// export const baseUrl='https://hztxgs.vote.ystykj.com';//二级现网
export const baseUrl='https://www.ystykj.com/';//二级现网
//访问图片URL
export const imgBSUrl='https://www.ystykj.com:9569/';
//
// export const totalSize=0;
// export const currentPage=1;



// WEBPACK FOOTER //
// ./src/api/config.js